import { Grid } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import urls from 'backend_urls';
import moment from 'moment'
import 'moment/locale/th';
import { toast } from 'react-toastify';
import { useQuery } from '@apollo/client';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API_CURRENCY_QUERY } from 'graphql/query';

export default function generateRandomString() {
	return Math.random().toString(36).substring(7);
}

export const getFromLocalStorage = (name) => {
	let receivedItem = window.localStorage.getItem(name);
	if (receivedItem) return receivedItem;
	return false;
};
export const renderDynamicIcon = (icon) => {
	const IconComponent = icon; // Assuming icon is a React component
	return <IconComponent />;
};

export const setInLocalStorage = (name, value) => {
	window.localStorage.setItem(name, value);
	let receivedItem = getFromLocalStorage(name);
	if (receivedItem) return receivedItem;
	return false;
};
export const deleteFromLocalStorage = (name) => {
	window.localStorage.removeItem(name);
	return true;
};

export const setCookie = (name, value, days) => {
	const expiryDate = new Date();
	expiryDate.setDate(expiryDate.getDate() + days);
	const cookieValue = encodeURIComponent(value) + '; expires=' + expiryDate.toUTCString();
	document.cookie = name + '=' + cookieValue + '; path=/';
	if (days <= 0) window.localStorage.removeItem(name);
	else setInLocalStorage(name, value);
};
export const getCookie = (name) => {
	const cookieString = document.cookie;
	const cookies = cookieString.split(';');

	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i].trim();

		if (cookie.startsWith(name + '=')) {
			const cookieValue = cookie.substring(name.length + 1);
			setInLocalStorage(name, cookieValue);
			return decodeURIComponent(cookieValue);
		}
	}
	let localStorageCookie = getFromLocalStorage(name);
	if (localStorageCookie) setCookie(name, localStorageCookie, 30);
	return null;
};

export const getCookieExpiryTime = (name) => {
	const cookieString = document.cookie;
	const cookies = cookieString.split(';');

	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i].trim();

		if (cookie.startsWith(name + '=')) {
			const cookieAttributes = cookie.substring(name.length + 1).split(';');
			const expiryAttribute = cookieAttributes.find((attr) => attr.trim().startsWith('expires='));

			if (expiryAttribute) {
				const expiryTimeString = expiryAttribute.substring('expires='.length);
				return new Date(expiryTimeString).getTime();
			}
		}
	}

	return null;
};
export const isLoggedIn = () => {
	let token = getCookie('token');
	if (token !== null && token !== undefined && token !== '') return token;
	let localStorageCookie = getFromLocalStorage('token');
	if (localStorageCookie) {
		setCookie('token', localStorageCookie, 30);
		return localStorageCookie;
	}
	return false;
};
export const logoutUser = () => {
	if (getCookie('token') !== null && getCookie('token') !== undefined && getCookie('token') !== '') {
		setCookie('token', null, -1);
		window.localStorage.removeItem('token');
		// window.localStorage.removeItem('user');
		setGlobalToastMessage('success', 'You successfully logged out.');
		return true;
	}
	return true;
};
export const isBrowser = () => {
	// Check if the navigator object is available
	if (typeof navigator !== 'undefined') {
		// Check if the user agent includes 'WebView' string
		let is_android = navigator.userAgent.includes('__TerraCharge_India_Android__');
		let is_ios = navigator.userAgent.includes('__TerraCharge_India_IOS__');
		if (is_android || is_ios) return false;
	}
	return true;
};

export const whichAppOsIsThis = () => {
	// Check if the navigator object is available
	if (typeof navigator !== 'undefined') {
		// Check if the user agent includes 'WebView' string
		if (navigator.userAgent.includes('__TerraCharge_India_Android__')) return 'android';
		if (navigator.userAgent.includes('__TerraCharge_India_IOS__')) return 'ios';
		return 'browser';
	}
	return false;
};

export const authHeaders = () => {
	let token = isLoggedIn();
	let headers = {
		'Content-Type': 'application/json'
	};
	const country = getFromLocalStorage('country')
	const language = getFromLocalStorage('selectedLanguage')
	if (country && language) {
		headers = { ...headers, 'x-country': country.toLowerCase(), 'x-language': language.toLowerCase() }
	}
	if (token) headers.Authorization = `Bearer ${token}`;
	return headers;
};

export const navigation_using_google_map = (location) => {
	var win = window.open(`https://maps.google.com/?q=${location.lat},${location.lng}&z=14`, '_blank');
	win.focus();
	return;
};

export const navigation_using_google_map_station_list = (location) => {
	var win = window.open(`https://maps.google.com/?q=${location}&z=14`, '_blank');
	win.focus();
	return;
};

export const epochToDateTime = (epochTime) => {

	return formatDateTime(moment.unix(epochTime))


	// const dateObj = new Date(epochTime * 1000);
	// const options = {
	// 	year: 'numeric',
	// 	month: '2-digit',
	// 	day: '2-digit',
	// 	hour: 'numeric',
	// 	minute: 'numeric',
	// 	second: 'numeric',
	// 	hour12: true // Display in 12-hour format (AM/PM)
	// };
	// const formattedDateTime = dateObj.toLocaleString(undefined, options);
	// return formattedDateTime;
};

export const wattToKiloWatt = (watt) => {
	const kiloWatt = parseFloat(watt / 1000);
	return kiloWatt.toFixed(3);
};

export const formatDate = (inputDate) => {
	const date = new Date(inputDate);
	const day = date.getDate();
	const month = date.getMonth() + 1;
	const year = date.getFullYear();
	const hours = date.getHours();
	const minutes = date.getMinutes();
	const ampm = hours >= 12 ? 'pm' : 'am';

	// Adjust hours to 12-hour format
	const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

	// Add leading zeros to day, month, hours, and minutes if needed
	const formattedDay = day < 10 ? `0${day}` : day;
	const formattedMonth = month < 10 ? `0${month}` : month;
	const formattedHoursWithZero = formattedHours < 10 ? `0${formattedHours}` : formattedHours;
	const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

	return `${formattedDay}/${formattedMonth}/${year} ${formattedHoursWithZero}:${formattedMinutes} ${ampm}`;
};

export const toastContainer = () => {
	return (
		<ToastContainer
			position="bottom-center"
			autoClose={800}
			hideProgressBar={false}
			newestOnTop={true}
			closeOnClick={true}
			rtl={false}
			pauseOnFocusLoss={false}
			draggable
			pauseOnHover
			theme="colored"
		/>
	);
};

export const setGlobalToastMessage = (type, message) => {
	let toast_message = JSON.stringify({ type: type, message: message });
	setInLocalStorage('toast_message', toast_message);
	return true;
};

export const handleUnauthorizedAccess = (error) => {
	if (error?.code === 'ER0x1103') {
		setInLocalStorage('login_next', window.location.pathname);
		setGlobalToastMessage('error', 'You have been logged out.');
		// navigate('/login');
		window.location.href = '/onboarding/phone';
	}
	return true;
};

export const downloadApp = (size) => {
	return (
		<Grid container paddingTop={2} rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={6} display="flex" justifyContent="center" alignItems="center">
				<a href={`${process.env.REACT_APP_PLAY_STORE_URL}`}>
					<img
						height={size}
						alt="playstore"
						src="data:image/png;base64,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"
					></img>
				</a>
			</Grid>
			<Grid item xs={6} display="flex" justifyContent="center" alignItems="center">
				<a href={`${process.env.REACT_APP_APP_STORE_URL}`}>
					<img
						alt="appstore"
						height={size}
						src="data:image/webp;base64,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"
					></img>
				</a>
			</Grid>
		</Grid>
	);
};

export const formatTime = (date) => {
	const options = { hour: 'numeric', minute: 'numeric' };
	return date.toLocaleString('en-US', options);
};

export const formatDateTime = (datetime) => {
	const langCode = getFromLocalStorage('selectedLanguage') || 'en'
	moment.locale(langCode)

	const dt = moment(datetime)

	return langCode === 'th' ? dt.add(543, 'year').format('D MMM YYYY H:mm น.') : dt.format('Do MMM YYYY h:mm a')

	// const dateObject = new Date(datetime);

	// const day = dateObject.getDate();
	// const month = dateObject.toLocaleString('default', { month: 'short' });
	// const year = dateObject.getFullYear();
	// const hours = dateObject.getHours();
	// const minutes = String(dateObject.getMinutes()).padStart(2, '0');
	// const ampm = hours >= 12 ? 'pm' : 'am';

	// const formattedDate = `${getOrdinalSuffix(day)} ${month} ${year} ${hours % 12 || 12}:${minutes} ${ampm}`;
	// return (formattedDate);

	// function getOrdinalSuffix(number) {
	// 	const suffixes = ['th', 'st', 'nd', 'rd'];
	// 	const v = number % 100;
	// 	return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
	// }
};

export const timeAgoString = (datetimeString) => {
	const currentTime = new Date();
	const inputTime = new Date(datetimeString);
	const timeDifference = currentTime - inputTime;
	const seconds = Math.floor(timeDifference / 1000);

	if (seconds < 60) {
		return `${seconds} seconds ago`;
	} else if (seconds < 3600) {
		const minutes = Math.floor(seconds / 60);
		return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
	} else if (seconds < 86400) {
		const hours = Math.floor(seconds / 3600);
		return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
	} else if (seconds < 172800) {
		return `yesterday at ${formatTime(inputTime)}`;
	} else {
		const days = Math.floor(seconds / 86400);
		return `${days} ${days === 1 ? 'day' : 'days'} ago at ${formatTime(inputTime)}`;
	}
};

export const formatPerUnitPrice = (connector, currency) => {
	let unitValue = connector.per_unit;
	let unitLabel = connector.calculate_on_unit;
	if (unitValue === 1000) {
		unitValue = 1;
		unitLabel = 'kWh (unit)';
	}
	let perUnitPrice = `${currency} ${connector.price} / ${unitValue} ${unitLabel}`;
	if (connector?.is_valet_enabled) {
		perUnitPrice = `${currency} ${connector.valet_price} / ${connector.valet_unit} (valet)`;
	}
	return <>{perUnitPrice}</>;
};

export const portStatusColor = (status, is_connected, colorCode) => {
	if (!is_connected) return colorCode?.abandoned;
	if (status === 'charging') return colorCode?.charging;
	if (status === 'available') return colorCode?.available;
	if (status === 'finishing') return colorCode?.finishing;
	if (status === 'faulted') return colorCode?.faulted;
	if (status === 'preparing') return colorCode?.preparing;
	if (status === 'unavailable') return colorCode?.unavailable;
	if (status === 'initiated') return colorCode?.initiated;
	if (status === 'online') return colorCode?.online;
	if (status === 'offline') return colorCode?.offline;
	if (status === 'abandoned') return colorCode?.abandoned;
	if (status === 'completed') return colorCode?.completed;
};

export const facilityStatusColor = (status) => {
	if (status === 'Closed') return '#FFC941';
	if (status === 'Open') return '#30C48F';
	if (status === 'Maintenance') return '#FF7676';
};

export const onlineOffline = (status) => {
	if (status === true) return '#30C48F';
	if (status === false) return '#FFC941';
};

export const validateEmailAddress = (email) => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(email);
}

export const getGeoCoords = async () => new Promise((resolve, reject) => {
	if (!window.location.pathname.includes("wallet")) {
		if ("geolocation" in navigator) {
			navigator.geolocation.getCurrentPosition((pos) => {
				resolve(pos)
			})
		} else {
			reject(null)
		}
	}
})

export const getGeoCountryCode = async () => {

	const lsCountry = getFromLocalStorage('country')
	if (lsCountry) {
		return lsCountry
	} else {
		const coords = await getGeoCoords()
		if (coords) {
			const { latitude, longitude } = coords.coords

			const resp = await axios
				.get(`${urls.getGeoCountryCode}${latitude}/${longitude}/`, {
					headers: authHeaders
				})

			if (resp?.data?.data) {
				setInLocalStorage('country', resp.data.data)
				return resp.data.data
			}
		}
	}


	return false
}

export const formatTimeHourAndMinute = (seconds) => {
	const minutes = Math.floor(seconds / 60);
	return `${minutes}`;
};

export const isSessionActive = async () => {
	const apiUrl = urls.livePaidChargingSession;
	const headers = authHeaders();
	try {
		const response = await axios.get(apiUrl, { headers });
		return response.data.success;
	} catch (error) {
		toast.error(error.response.data.message)
		return null;
	}
};

export const isPenaltySessionActive = async () => {
	const apiUrl = urls.livePenaltySession;
	const headers = authHeaders();
	try {
		const response = await axios.get(apiUrl, { headers });
		return response.data.success;
	} catch (error) {
		console.error("Error fetching penalty session status:", error);
		return error.response?.data?.success;
	}
};

export const walletRecharge = async (data) => {
	const apiUrl = urls.walletRecharge;
	const headers = authHeaders();
	try {
		const response = await axios.post(apiUrl, data, { headers });
		return response.data;
	} catch (error) {
		toast.error(error.response.data.message)
		return null;
	}
};

export const getTokenFromLocalStorage = () => {
	return localStorage.getItem('token');
};

export const useCountryCurrency = () => {
	const [countryCurrency, setCountryCurrency] = useState(null);
	const location = useLocation();
	const token = localStorage.getItem('token');

	const { refetch, data } = useQuery(API_CURRENCY_QUERY, {
		variables: { token: token },
		skip: !token,
		onCompleted: (data) => {
			setCountryCurrency(data?.api_user[0]?.api_country?.currency);
		},
		onError: (err) => {
			console.error("Query error:", err);
		}
	});

	useEffect(() => {
		if (token) {
			refetch({ token: token }).catch(refetchError => {
				console.error("Refetch error:", refetchError);
			});
		}
	}, [location, token, refetch]);

	useEffect(() => {
		if (data) {
			if (data.api_user && data.api_user[0] && data.api_user[0].api_country) {
				setCountryCurrency(data.api_user[0].api_country.currency);
			}
		}
	}, [data]);

	return countryCurrency;
};


export function getMonthName(monthNumber) {
	const date = new Date(2000, monthNumber, 1);
	const monthName = date.toLocaleString('en-US', { month: 'long' });
	return monthName;
}

export function isEmpty(obj) {
	return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}

export const capitalizeFirstLetter = (string) => {
	if (!string) return string;
	return string.charAt(0).toUpperCase() + string.slice(1);
};

export async function getPlaceNameFromCoordinates(lat, lng) {
	const geocoder = new google.maps.Geocoder();
	const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };
	return new Promise((resolve, reject) => {
		geocoder.geocode({ location: latlng }, (results, status) => {
			if (status === "OK") {
				if (results[0]) {
					resolve(results[0].formatted_address);
				} else {
					reject('No results found');
				}
			} else {
				reject('Geocoder failed due to: ' + status);
			}
		});
	});
}


export async function getCurrentLocation() {
	return new Promise((resolve, reject) => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					const { latitude, longitude } = position.coords;
					resolve({ latitude, longitude });
				},
				(error) => {
					console.error('Geolocation error:', error.message);
					resolve(false);
				}
			);
		} else {
			console.error('Geolocation is not available.');
			resolve(false);
		}
	});
}

export const setModalClosed = () => {
	const now = new Date().getTime();
	const data = {
		value: "True",
		timestamp: now
	}
	localStorage.setItem('closeRequestModal', JSON.stringify(data));
}

export const isModalClosedRecently = () => {
	const itemStr = localStorage.getItem('closeRequestModal');

	if (!itemStr) {
		return false;
	}

	const item = JSON.parse(itemStr);
	const now = new Date().getTime();

	if (now - item.timestamp > 24 * 60 * 60 * 1000) {
		localStorage.removeItem('closeRequestModal');
		return false;
	}

	return item.value === "True";
};


export function hexToRgb(hex) {
	hex = hex?.replace(/^#/, '');

	// Parse the r, g, b values
	let r = parseInt(hex?.slice(0, 2), 16);
	let g = parseInt(hex?.slice(2, 4), 16);
	let b = parseInt(hex?.slice(4, 6), 16);

	return `rgb(${r}, ${g}, ${b}, 0.2)`;
}

export const compressImage = (file, quality) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = (event) => {
			const img = new Image();
			img.src = event.target.result;
			img.onload = () => {
				let width = img.width;
				let height = img.height;
				const maxSize = 500;

				if (width > height) {
					if (width > maxSize) {
						height = (height * maxSize) / width;
						width = maxSize;
					}
				} else {
					if (height > maxSize) {
						width = (width * maxSize) / height;
						height = maxSize;
					}
				}

				const canvas = document.createElement('canvas');
				canvas.width = width;
				canvas.height = height;
				const ctx = canvas.getContext('2d');

				ctx.drawImage(img, 0, 0, width, height);

				canvas.toBlob(
					(blob) => {
						if (blob) {
							resolve(new File([blob], file.name, { type: file.type }));
						} else {
							reject(new Error("Compression failed."));
						}
					},
					file.type,
					quality
				);
			};
		};

		reader.onerror = (error) => reject(error);
	});
};


export function timeAgo(seconds) {
	try {
		const currentTime = new Date();
		const pastTime = new Date(seconds * 1000);

		const delta = currentTime - pastTime;

		const secondsInMinute = 60;
		const secondsInHour = 3600;
		const secondsInDay = 86400;
		const secondsInWeek = 604800;
		const secondsInMonth = 2592000;  // Approx. 30 days
		const secondsInYear = 31536000;  // Approx. 365 days

		let message = '';

		if (delta < secondsInMinute * 1000) {
			message = "just now";
		} else if (delta < secondsInHour * 1000) {
			const minutes = Math.floor(delta / (secondsInMinute * 1000));
			message = `${minutes} min${minutes > 1 ? 's' : ''} ago`;
		} else if (delta < secondsInDay * 1000) {
			let hours = Math.floor(delta / (secondsInHour * 1000));
			const minutes = Math.floor((delta % (secondsInHour * 1000)) / (secondsInMinute * 1000));
			hours = hours + (minutes > 29 ? 1 : 0)
			message = `${hours} hr${hours > 1 ? 's' : ''} ago`
		} else if (delta < secondsInWeek * 1000) {
			const days = Math.floor(delta / (secondsInDay * 1000));
			message = `${days} day${days > 1 ? 's' : ''} ago`;
		} else if (delta < secondsInMonth * 1000) {
			const weeks = Math.floor(delta / (secondsInWeek * 1000));
			message = `${weeks} week${weeks > 1 ? 's' : ''} ago`;
		} else if (delta < secondsInYear * 1000) {
			const months = Math.floor(delta / (secondsInMonth * 1000));
			message = `${months} month${months > 1 ? 's' : ''} ago`;
		} else {
			const years = Math.floor(delta / (secondsInYear * 1000));
			message = `${years} year${years > 1 ? 's' : ''} ago`;
		}

		return message;
	}
	catch (error) {
		console.log(error);
		return False
	}
}

